import React, { useEffect, useRef } from "react";
import Footer from "../../../components/layout/Footer/Footer";
import {
  Container,
  H1q,
  H2q,
  ImgContainer,
  Text1,
  Span,
  Block,
  ImgBlock,
  TitleBlock,
  TextBlock,
  Box,
  Circle1,
  CircleText1,
  BoxText,
  BoxTitleB,
  BoxTitleN,
  CircleContainer,
  Box1,
  TextCont,
  TextBlock1,
  TitleBlock1,
  TextWrap,
  Box2,
  Box21,
  SmallText1,
  H1W,
  H2W,
  BtnW,
  FAQCont2,
  FAQuestion,
  Spinner,
  FAQCircle,
  FAQ1,
  InnerText,
  Btnq,
  SmallTextq,
  Btnq1,
  ImgContainerq,
  Qwerty,
  Programm,
  OuterContainer,
  EscapeBtn,
  ProrgammTitle,
  Tag,
  ProgrammText,
  ProgrammCloseAll,
  ProgrammCont,
  ProgrammSectionCont,
  FAQTextSmall,
  ProgrammBlock,
  ProgrammSpinner,
  ProgrammTextCont,
  ProgrammTextDiv4Li,
  ProgrammTextDiv4Li2,
  ProgrammUl,
  FAQTextSmall2,
  ProgrammBigText,
} from "./styles";
import { goTo, useNavigation } from "../../../types/Navigates";
import { Btn5, ScrollContainer2 } from "../../Main/styles";
import { FAQ } from "../../../components/FAQ/FAQ";
import { FAQText } from "../../../components/FAQ/styles";
import { Ratings } from "../../../components/Ratings/Ratings";
import urlText from "../../../types/urlText";
import { CircleContainer2 } from "../Services2/styles";
import { BoxText2, BoxTitleN2 } from "../Services1/styles";

const Services7 = () => {
  const { toServices, toConsult, toMain, toRatings } = useNavigation();
  const scrollcontainerRef = useRef(null);
  const innerTextRef1 = useRef(null);
  const innerTextRef2 = useRef(null);
  const innerTextRef3 = useRef(null);
  const innerTextRef4 = useRef(null);
  const ProgrammRef = useRef(null);
  const programmRef1 = useRef(null);
  const programmRef2 = useRef(null);
  const programmRef3 = useRef(null);
  const programmRef4 = useRef(null);
  const programmRef5 = useRef(null);
  const programmRef6 = useRef(null);
  const programmRef7 = useRef(null);
  const programmRef8 = useRef(null);
  const programmRef9 = useRef(null);

  useEffect(() => {
    const scrollcontainer = scrollcontainerRef.current;
    const innerText1 = innerTextRef1.current;
    const innerText2 = innerTextRef2.current;
    const innerText3 = innerTextRef3.current;
    const innerText4 = innerTextRef4.current;
    const Programm = ProgrammRef.current;
    const Programm1 = programmRef1.current;
    const Programm2 = programmRef2.current;
    const Programm3 = programmRef3.current;
    const Programm4 = programmRef4.current;
    const Programm5 = programmRef5.current;
    const Programm6 = programmRef6.current;
    const Programm7 = programmRef7.current;
    const Programm8 = programmRef8.current;
    const Programm9 = programmRef9.current;
  });
  const ShowProgramm = () => {
    if (ProgrammRef.current) {
      ProgrammRef.current.style.display = "block";
    }
    window.scrollTo(0, 0);
  };

  const CloseProgramm = () => {
    if (ProgrammRef.current) {
      ProgrammRef.current.style.display = "none";
    }
  };

  const scroll = () => {
    if (scrollcontainerRef.current) {
      scrollcontainerRef.current.addEventListener("wheel", (evt) => {
        evt.preventDefault();
        scrollcontainerRef.current.scrollLeft += evt.deltaY;
      });
    }
  };
  const ShowinnerText1 = () => {
    if (innerTextRef1.current) {
      innerTextRef1.current.style.display == "none"
        ? (innerTextRef1.current.style.display = "block")
        : (innerTextRef1.current.style.display = "none");
    }
  };
  const ShowinnerText2 = () => {
    if (innerTextRef2.current) {
      innerTextRef2.current.style.display == "none"
        ? (innerTextRef2.current.style.display = "block")
        : (innerTextRef2.current.style.display = "none");
    }
  };
  const ShowinnerText3 = () => {
    if (innerTextRef3.current) {
      innerTextRef3.current.style.display == "none"
        ? (innerTextRef3.current.style.display = "block")
        : (innerTextRef3.current.style.display = "none");
    }
  };
  const ShowinnerText4 = () => {
    if (innerTextRef4.current) {
      innerTextRef4.current.style.display == "none"
        ? (innerTextRef4.current.style.display = "block")
        : (innerTextRef4.current.style.display = "none");
    }
  };
  const ShowProgramm1 = () => {
    if (programmRef1.current) {
      programmRef1.current.style.display == "none"
        ? (programmRef1.current.style.display = "block")
        : (programmRef1.current.style.display = "none");
    }
  };
  const ShowProgramm2 = () => {
    if (programmRef2.current) {
      programmRef2.current.style.display == "none"
        ? (programmRef2.current.style.display = "block")
        : (programmRef2.current.style.display = "none");
    }
  };
  const ShowProgramm3 = () => {
    if (programmRef3.current) {
      programmRef3.current.style.display == "none"
        ? (programmRef3.current.style.display = "block")
        : (programmRef3.current.style.display = "none");
    }
  };
  const ShowProgramm4 = () => {
    if (programmRef4.current) {
      programmRef4.current.style.display == "none"
        ? (programmRef4.current.style.display = "block")
        : (programmRef4.current.style.display = "none");
    }
  };
  const ShowProgramm5 = () => {
    if (programmRef5.current) {
      programmRef5.current.style.display == "none"
        ? (programmRef5.current.style.display = "block")
        : (programmRef5.current.style.display = "none");
    }
  };
  const ShowProgramm6 = () => {
    if (programmRef6.current) {
      programmRef6.current.style.display == "none"
        ? (programmRef6.current.style.display = "block")
        : (programmRef6.current.style.display = "none");
    }
  };
  const ShowProgramm7 = () => {
    if (programmRef7.current) {
      programmRef7.current.style.display == "none"
        ? (programmRef7.current.style.display = "block")
        : (programmRef7.current.style.display = "none");
    }
  };
  const ShowProgramm8 = () => {
    if (programmRef8.current) {
      programmRef8.current.style.display == "none"
        ? (programmRef8.current.style.display = "block")
        : (programmRef8.current.style.display = "none");
    }
  };
  const ShowProgramm9 = () => {
    if (programmRef9.current) {
      programmRef9.current.style.display == "none"
        ? (programmRef9.current.style.display = "block")
        : (programmRef9.current.style.display = "none");
    }
  };
  const CloseAll = () => {
    if (
      programmRef1.current &&
      programmRef2.current &&
      programmRef3.current &&
      programmRef4.current &&
      programmRef5.current &&
      programmRef6.current
    ) {
      programmRef1.current.style.display = "none";
      programmRef2.current.style.display = "none";
      programmRef3.current.style.display = "none";
      programmRef4.current.style.display = "none";
      programmRef5.current.style.display = "none";
      programmRef6.current.style.display = "none";
    }
  };
  const CloseAll2 = () => {
    if (programmRef7.current && programmRef8.current && programmRef9.current) {
      programmRef7.current.style.display = "none";
      programmRef8.current.style.display = "none";
      programmRef9.current.style.display = "none";
    }
  };

  return (
    <>
      <ImgContainer $img={require("./bg.png")}>
        <H1q>Обучение профессии IT Рекрутер</H1q>
        <H2q>
          Авторский курс Любови Прохоровой, который позволит не только обучиться
          профессии, но и устроиться на первую работу внутри обучения.
        </H2q>
        <Btnq onClick={toConsult}>Бесплатная консультация</Btnq>
      </ImgContainer>
      <Container>
        <Text1>
          Кому подходит
          <Span>обучение?</Span>
        </Text1>
      </Container>
      <Container>
        <Block>
          <ImgBlock $img={require("./v1.png")} />
          <TitleBlock>Удаленная работа</TitleBlock>
          <TextBlock>Для тех, кто хочет работать удаленно</TextBlock>
        </Block>
        <Block>
          <ImgBlock $img={require("./v2.png")} />
          <TitleBlock>Перейти в IT индустрию</TitleBlock>
          <TextBlock>Стать часть мирового Tech сообщества</TextBlock>
        </Block>
        <Block>
          <ImgBlock $img={require("./v3.png")} />
          <TitleBlock>Много зарабатывать</TitleBlock>
          <TextBlock>Давай вместе зарабатывать как разработчик</TextBlock>
        </Block>
      </Container>
      <Text1>Как строится работа?</Text1>
      <Container>
        <Box>
          <CircleContainer2>
            <Circle1 />
            <CircleText1>01</CircleText1>
          </CircleContainer2>
          <BoxTitleN>Блок</BoxTitleN>
          <BoxTitleB>Теории</BoxTitleB>
          <BoxText>
            6 недель теоретического блока: уроки, онлайн разборы, вебинары и
            дипломная работа
          </BoxText>
        </Box>
        <Box>
          <CircleContainer2>
            <Circle1 />
            <CircleText1>02</CircleText1>
          </CircleContainer2>
          <BoxTitleN>Практическая</BoxTitleN>
          <BoxTitleB>Работа</BoxTitleB>
          <BoxText>
            4 недели настоящей работы в роли IT рекрутера под присмотром Любови
            Прохоровой
          </BoxText>
        </Box>
        <Box>
          <CircleContainer2>
            <Circle1 />
            <CircleText1>03</CircleText1>
          </CircleContainer2>
          <BoxTitleN>Онлайн</BoxTitleN>
          <BoxTitleB>Выпускной</BoxTitleB>
          <BoxText>
            Проведение онлайн выпускного и карьерная подготовка к поиску работы
          </BoxText>
        </Box>
        <Box1>
          <CircleContainer2>
            <Circle1 />
            <CircleText1>04</CircleText1>
          </CircleContainer2>
          <BoxTitleN>Поиск</BoxTitleN>
          <BoxTitleB>Работы</BoxTitleB>
          <BoxText>
            4 недели совместного поиска работы: организация интервью с
            компаниями-партнерами, показ вакансий, помощь с тестовыми заданиями
          </BoxText>
        </Box1>
      </Container>
      <br />
      <br />
      <Text1>
        Что вы получите<Span>в итоге ?</Span>
      </Text1>

      <Programm ref={ProgrammRef}>
        <OuterContainer>
          <EscapeBtn onClick={CloseProgramm}>X</EscapeBtn>
          <ProrgammTitle>Программа курса</ProrgammTitle>
          <Tag>Теория</Tag>

          <ProgrammCont>
            <ProgrammText>Обучающая программа. 6 недель</ProgrammText>
            <ProgrammCloseAll onClick={CloseAll}>
              Cвернуть все разделы
            </ProgrammCloseAll>
          </ProgrammCont>

          <ProgrammSectionCont>
            <ProgrammBlock>
              <ProgrammTextCont>
                <FAQText>Основы IT подбора</FAQText>
                <FAQTextSmall>2 урока</FAQTextSmall>
              </ProgrammTextCont>
              <ProgrammSpinner
                onClick={ShowProgramm1}
                $img={require("./Icon.png")}
              />
            </ProgrammBlock>
            <InnerText ref={programmRef1}>
              <FAQTextSmall2>1-ая неделя</FAQTextSmall2>
              <ProgrammUl>
                <ProgrammTextDiv4Li>
                  <ProgrammTextDiv4Li2>
                    ⁠​‌‍‎ Узнаешь об IT подборе, его задачах и основных этапах.
                  </ProgrammTextDiv4Li2>
                </ProgrammTextDiv4Li>
                <ProgrammTextDiv4Li>
                  <ProgrammTextDiv4Li2>
                    ⁠​‌‍‎ Онлайн разбор вопросов с преподавателем.
                  </ProgrammTextDiv4Li2>
                </ProgrammTextDiv4Li>
              </ProgrammUl>
            </InnerText>
          </ProgrammSectionCont>

          <ProgrammSectionCont>
            <ProgrammBlock>
              <ProgrammTextCont>
                <FAQText>Технический минимум</FAQText>
                <FAQTextSmall>2 урока</FAQTextSmall>
              </ProgrammTextCont>
              <ProgrammSpinner
                onClick={ShowProgramm2}
                $img={require("./Icon.png")}
              />
            </ProgrammBlock>
            <InnerText ref={programmRef2}>
              <FAQTextSmall2>2-ая неделя</FAQTextSmall2>
              <ProgrammBigText>
                Узнаешь основные профессии в IT, познакомишься с современными
                технологиями и будешь как рыба в мире разработки.
              </ProgrammBigText>
              <ProgrammUl>
                <ProgrammTextDiv4Li>
                  <ProgrammTextDiv4Li2>
                    ⁠​‌‍‎ Узнаешь об IT подборе, его задачах и основных этапах.
                  </ProgrammTextDiv4Li2>
                </ProgrammTextDiv4Li>
                <ProgrammTextDiv4Li>
                  <ProgrammTextDiv4Li2>
                    ⁠​‌‍‎ Онлайн вебинар с действующим Разработчиком.
                  </ProgrammTextDiv4Li2>
                </ProgrammTextDiv4Li>
                <ProgrammTextDiv4Li>
                  <ProgrammTextDiv4Li2>
                    ⁠​‌‍‎ Онлайн вебинар по техническому минимуму с
                    преподавателем.
                  </ProgrammTextDiv4Li2>
                </ProgrammTextDiv4Li>
              </ProgrammUl>
            </InnerText>
          </ProgrammSectionCont>

          <ProgrammSectionCont>
            <ProgrammBlock>
              <ProgrammTextCont>
                <FAQText>Сорсинг</FAQText>
                <FAQTextSmall>2 урока</FAQTextSmall>
              </ProgrammTextCont>
              <ProgrammSpinner
                onClick={ShowProgramm3}
                $img={require("./Icon.png")}
              />
            </ProgrammBlock>
            <InnerText ref={programmRef3}>
              <FAQTextSmall2>3-ая неделя</FAQTextSmall2>
              <ProgrammBigText>
                Научишься искать IT-специалистов лучше, чем Шерлок Холмс
                преступников.
              </ProgrammBigText>
              <ProgrammUl>
                <ProgrammTextDiv4Li>
                  <ProgrammTextDiv4Li2>
                    ⁠​‌‍‎ Онлайн разбор вопросов с преподавателем.
                  </ProgrammTextDiv4Li2>
                </ProgrammTextDiv4Li>
                <ProgrammTextDiv4Li>
                  <ProgrammTextDiv4Li2>
                    ⁠​‌‍‎ Онлайн соревнование по сорсингу.
                  </ProgrammTextDiv4Li2>
                </ProgrammTextDiv4Li>
                <ProgrammTextDiv4Li>
                  <ProgrammTextDiv4Li2>
                    ⁠​‌‍‎ Онлайн вебинар с действующим IT специалистом.
                  </ProgrammTextDiv4Li2>
                </ProgrammTextDiv4Li>
              </ProgrammUl>
            </InnerText>
          </ProgrammSectionCont>

          <ProgrammSectionCont>
            <ProgrammBlock>
              <ProgrammTextCont>
                <FAQText>Все о текстах в IT подборе</FAQText>
                <FAQTextSmall>2 урока</FAQTextSmall>
              </ProgrammTextCont>
              <ProgrammSpinner
                onClick={ShowProgramm4}
                $img={require("./Icon.png")}
              />
            </ProgrammBlock>
            <InnerText ref={programmRef4}>
              <FAQTextSmall2>4-ая неделя</FAQTextSmall2>
              <ProgrammBigText>
                Узнаешь, какие есть тексты в IT подборе и научишься писать
                вакансии, письма и рекомендации в своем уникальном стиле.
              </ProgrammBigText>
              <ProgrammUl>
                <ProgrammTextDiv4Li>
                  <ProgrammTextDiv4Li2>
                    ⁠​‌‍‎ Онлайн разбор вопросов с преподавателем.
                  </ProgrammTextDiv4Li2>
                </ProgrammTextDiv4Li>
                <ProgrammTextDiv4Li>
                  <ProgrammTextDiv4Li2>
                    ⁠​‌‍‎ Онлайн вебинар с действующим IT разработчиком.
                  </ProgrammTextDiv4Li2>
                </ProgrammTextDiv4Li>
              </ProgrammUl>
            </InnerText>
          </ProgrammSectionCont>

          <ProgrammSectionCont>
            <ProgrammBlock>
              <ProgrammTextCont>
                <FAQText>Коммуникация в IT подборе</FAQText>
                <FAQTextSmall>2 урока</FAQTextSmall>
              </ProgrammTextCont>
              <ProgrammSpinner
                onClick={ShowProgramm5}
                $img={require("./Icon.png")}
              />
            </ProgrammBlock>
            <InnerText ref={programmRef5}>
              <FAQTextSmall2>5-ая неделя</FAQTextSmall2>
              <ProgrammBigText>
                Научишься правильно выстраивать коммуникацию с каждым участником
                процесса подбора.
              </ProgrammBigText>
              <ProgrammUl>
                <ProgrammTextDiv4Li>
                  <ProgrammTextDiv4Li2>
                    ⁠​‌‍‎ Научишься правильно выстраивать коммуникацию с каждым
                    участником процесса подбора.
                  </ProgrammTextDiv4Li2>
                </ProgrammTextDiv4Li>
                <ProgrammTextDiv4Li>
                  <ProgrammTextDiv4Li2>
                    ⁠​‌‍‎ Онлайн разбор вопросов с преподавателем.
                  </ProgrammTextDiv4Li2>
                </ProgrammTextDiv4Li>
              </ProgrammUl>
            </InnerText>
          </ProgrammSectionCont>

          <ProgrammSectionCont>
            <ProgrammBlock>
              <ProgrammTextCont>
                <FAQText>Дипломная работа</FAQText>
              </ProgrammTextCont>
              <ProgrammSpinner
                onClick={ShowProgramm6}
                $img={require("./Icon.png")}
              />
            </ProgrammBlock>
            <InnerText ref={programmRef6}>
              <FAQTextSmall2>6-ая неделя</FAQTextSmall2>
              <ProgrammUl>
                <ProgrammTextDiv4Li>
                  <ProgrammTextDiv4Li2>
                    ⁠​‌‍‎ Обсуждение заданий с преподавателем.
                  </ProgrammTextDiv4Li2>
                </ProgrammTextDiv4Li>
                <ProgrammTextDiv4Li>
                  <ProgrammTextDiv4Li2>
                    ⁠​‌‍‎ Выдача сертификатов.
                  </ProgrammTextDiv4Li2>
                </ProgrammTextDiv4Li>
              </ProgrammUl>
            </InnerText>
          </ProgrammSectionCont>

          <br />
          <br />
          <br />
          <Tag>Практика</Tag>

          <ProgrammCont>
            <ProgrammText>Оттачиваем навыки на практике. 8 недель</ProgrammText>
            <ProgrammCloseAll onClick={CloseAll2}>
              Cвернуть все разделы
            </ProgrammCloseAll>
          </ProgrammCont>

          <ProgrammSectionCont>
            <ProgrammBlock>
              <ProgrammTextCont>
                <FAQText>Вводим в курс дела</FAQText>
              </ProgrammTextCont>
              <ProgrammSpinner
                onClick={ShowProgramm7}
                $img={require("./Icon.png")}
              />
            </ProgrammBlock>
            <InnerText ref={programmRef7}>
              <FAQTextSmall2>1-ая неделя</FAQTextSmall2>
              <ProgrammBigText>
                Научишься правильно выстраивать коммуникацию с каждым участником
                процесса подбора.
              </ProgrammBigText>
              <ProgrammUl>
                <ProgrammTextDiv4Li>
                  <ProgrammTextDiv4Li2>
                    ⁠​‌‍‎ Онлайн вебинар по практике.
                  </ProgrammTextDiv4Li2>
                </ProgrammTextDiv4Li>
                <ProgrammTextDiv4Li>
                  <ProgrammTextDiv4Li2>
                    ⁠​‌‍‎ Онлайн созвон по обсуждению вопросов.
                  </ProgrammTextDiv4Li2>
                </ProgrammTextDiv4Li>
                <ProgrammTextDiv4Li>
                  <ProgrammTextDiv4Li2>
                    ⁠​‌‍‎ Проверка и корректировка заданий от куратора.
                  </ProgrammTextDiv4Li2>
                </ProgrammTextDiv4Li>
              </ProgrammUl>
            </InnerText>
          </ProgrammSectionCont>

          <ProgrammSectionCont>
            <ProgrammBlock>
              <ProgrammTextCont>
                <FAQText>Практика</FAQText>
              </ProgrammTextCont>
              <ProgrammSpinner
                onClick={ShowProgramm8}
                $img={require("./Icon.png")}
              />
            </ProgrammBlock>
            <InnerText ref={programmRef8}>
              <FAQTextSmall2>2 – 4 ая неделя</FAQTextSmall2>
              <ProgrammBigText>
                Настоящая работа в роли специалиста IT подбора внутри команды
                студентов под наблюдением куратора.
              </ProgrammBigText>
              <ProgrammUl>
                <ProgrammTextDiv4Li>
                  <ProgrammTextDiv4Li2>
                    ⁠​‌‍‎ Онлайн разбор вопросов 2 раза в неделю.
                  </ProgrammTextDiv4Li2>
                </ProgrammTextDiv4Li>
                <ProgrammTextDiv4Li>
                  <ProgrammTextDiv4Li2>
                    ⁠​‌‍‎ Обратная связь по работе в чате 24/7.
                  </ProgrammTextDiv4Li2>
                </ProgrammTextDiv4Li>
                <ProgrammTextDiv4Li>
                  <ProgrammTextDiv4Li2>
                    ⁠​‌‍‎ ОЕженедельный вебинар: работа над Linkedin, командный
                    коучинг «постановка целей», практическая игра «закрой
                    оффер».
                  </ProgrammTextDiv4Li2>
                </ProgrammTextDiv4Li>
              </ProgrammUl>
            </InnerText>
          </ProgrammSectionCont>

          <ProgrammSectionCont>
            <ProgrammBlock>
              <ProgrammTextCont>
                <FAQText>
                  Завершение практического блока, сопровождение поиска работы
                </FAQText>
              </ProgrammTextCont>
              <ProgrammSpinner
                onClick={ShowProgramm9}
                $img={require("./Icon.png")}
              />
            </ProgrammBlock>
            <InnerText ref={programmRef9}>
              <FAQTextSmall2>4 – 8 ая неделя</FAQTextSmall2>
              <ProgrammUl>
                <ProgrammTextDiv4Li>
                  <ProgrammTextDiv4Li2>
                    ⁠​‌‍‎ Проведение онлайн выпускного.
                  </ProgrammTextDiv4Li2>
                </ProgrammTextDiv4Li>
                <ProgrammTextDiv4Li>
                  <ProgrammTextDiv4Li2>
                    ⁠​‌‍‎ Вебинар по созданию резюме.
                  </ProgrammTextDiv4Li2>
                </ProgrammTextDiv4Li>
                <ProgrammTextDiv4Li>
                  <ProgrammTextDiv4Li2>
                    ⁠​‌‍‎ Корректировка резюме куратором.
                  </ProgrammTextDiv4Li2>
                </ProgrammTextDiv4Li>
                <ProgrammTextDiv4Li>
                  <ProgrammTextDiv4Li2>
                    ⁠​‌‍‎ Вебинар по поиску работы.
                  </ProgrammTextDiv4Li2>
                </ProgrammTextDiv4Li>
                <ProgrammTextDiv4Li>
                  <ProgrammTextDiv4Li2>
                    ⁠​‌‍‎ Организация собеседований в компании-партнеры.
                  </ProgrammTextDiv4Li2>
                </ProgrammTextDiv4Li>
                <ProgrammTextDiv4Li>
                  <ProgrammTextDiv4Li2>
                    ⁠​‌‍‎ Ежедневная отправка вакансий в чат группы.
                  </ProgrammTextDiv4Li2>
                </ProgrammTextDiv4Li>
              </ProgrammUl>
            </InnerText>
          </ProgrammSectionCont>
        </OuterContainer>
      </Programm>

      <Container>
        <ImgContainerq $img={require("./bg2.png")}>
          <Btnq1 onClick={ShowProgramm}>Программа обучения</Btnq1>
        </ImgContainerq>
        <TextCont>
          <TextWrap>
            <TitleBlock1>Профессию в IT индустрии</TitleBlock1>
            <TextBlock1>
              Авторская методика, позволяющая трудоустроиться уже внутри
              обучения.
            </TextBlock1>
          </TextWrap>
          <TextWrap>
            <TitleBlock1>Коммерческий опыт работы как IT Рекрутер</TitleBlock1>
            <TextBlock1>
              Единственный курс по IT подбору, который ориентирован на
              трудоустройство студентов.
            </TextBlock1>
          </TextWrap>
        </TextCont>
      </Container>
      <Qwerty />
      <Text1>
        Мы приносим<Span>результат</Span>
      </Text1>
      <Container>
        <Box>
          <BoxTitleN2>60+</BoxTitleN2>
          <BoxText2>Студентов</BoxText2>
        </Box>
        <Box2>
          <BoxTitleN2>3</BoxTitleN2>
          <BoxText2>
            Недели, среднее время поиска работы наших студентов
          </BoxText2>
        </Box2>
        <Box2>
          <BoxTitleN2>x3</BoxTitleN2>
          <BoxText2>Средний рост зарплаты наших студентов за год</BoxText2>
        </Box2>
        <Box2>
          <BoxTitleN2>10</BoxTitleN2>
          <BoxText2>Стран, где живут наши студентов</BoxText2>
        </Box2>
        <Box21>
          <BoxTitleN2>2+</BoxTitleN2>
          <BoxText2>Года мы обучаем профессиям IT подбора</BoxText2>
        </Box21>
      </Container>
      <br />
      <br />
      <br />
      <ImgContainer $img={require("./bg4.png")}>
        <SmallTextq>бесплатная консультация</SmallTextq>
        <H1q>Оставить заявку</H1q>
        <H2q>
          Консультация-знакомство это возможность получить ответы на все
          волнующие вопросы
        </H2q>
        <Btnq href="https://t.me/ProhorovaConsult">Получить консультацию</Btnq>
      </ImgContainer>
      <Text1>Отзывы</Text1>
      <ScrollContainer2 ref={scrollcontainerRef} >
        <Ratings />
      </ScrollContainer2>
      <Btn5 onClick={toRatings}>Все отзывы</Btn5>
      <ImgContainer $img={require("./bg3.png")}>
        <SmallText1>бесплатная консультация</SmallText1>
        <H1W>Остались вопросы ?</H1W>
        <H2W>
          Консультация-знакомство это возможность получить ответы на все
          волнующие вопросы.
        </H2W>
        <BtnW href={`https://t.me/ProhorovaConsult?text=${urlText}`}>
          Оставить заявку
        </BtnW>
      </ImgContainer>
      <br />
      <br />
      <br />
      <br />
      <Container>
        <FAQ />
        <FAQCont2>
          <FAQuestion>
            <FAQ1>
              <FAQCircle />
              <FAQText>На каких позициях я могу работать ?</FAQText>
            </FAQ1>
            <Spinner onClick={ShowinnerText1} $img={require("./Icon.png")} />
          </FAQuestion>
          <InnerText ref={innerTextRef1}>
            После обучения вы можете работать сорсером, рекрутером и
            HR-менеджером в IT индустрии.
          </InnerText>
          <FAQuestion>
            <FAQ1>
              <FAQCircle />
              <FAQText>Можно совмещать работу с обучением ?</FAQText>
            </FAQ1>
            <Spinner onClick={ShowinnerText2} $img={require("./Icon.png")} />
          </FAQuestion>
          <InnerText ref={innerTextRef2}>
            Да, более 30 наших выпускников совмещали работу с обучением и с
            личными делами. У вас не будет трудностей, чтобы все комфортно
            успеть.
          </InnerText>
          <FAQuestion>
            <FAQ1>
              <FAQCircle />
              <FAQText>Возможен ли возврат средств ?</FAQText>
            </FAQ1>
            <Spinner onClick={ShowinnerText4} $img={require("./Icon.png")} />
          </FAQuestion>
          <InnerText ref={innerTextRef4}>Да, он прописан в договоре.</InnerText>
        </FAQCont2>
      </Container>
      <Footer />
    </>
  );
};
export default Services7;
